/*
 * @Author: “zhangjiahao04”
 * @Date: 2023-08-23 15:50:14
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-19 17:40:09
 * @FilePath: \pico-ow2c-fe\src\pages\outer\about\index.tsx
 * @Description: 关于我们——banner 组件
 * @url:www.picoxr.com/cn/about
 */
import styles from "../../index.module.scss";
import React from "react";
import { useDevice } from "@/hooks";
import { Carousel } from "@arco-design/web-react";
import { IBanner } from "@/common/types";
import LazyMedia from "@/components/LazyMedia";
interface ImageGalleryProps {
  banners: IBanner[]; // banner列表
}

const Banner: React.FC<ImageGalleryProps> = ({ banners }) => {
  // 判断banner不同屏幕下展示图片还是视频
  const device = useDevice();
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)

  return (
    <>{banners && banners.length > 0  &&(
      <div  className={styles["banner-warp"]}>
        <Carousel
          className={styles['banner-carousel']}
          autoPlay={true}
          indicatorType='dot'
          showArrow='hover'>
          {banners && banners.map((item, index) => {
              return (
                <div key={item.id} className={styles["banner-content-wrap"]}>
                  {
                    item[newDevice].extension === '.mp4'
                    ? <LazyMedia LazyClassName='full-wh' type="video" loop autoPlay preload="auto" playsInline muted src={item[newDevice]?.url} className={styles["banner-video"]}></LazyMedia>
                    : <LazyMedia LazyClassName='full-wh' type="image" src={item[newDevice]?.url} alt={item[newDevice]?.alt} className={styles["banner-image"]} />
                  }
                  <div className={styles["banner-content"]}>
                    {item?.isShowTitle === 1 && (
                      <h1 className={styles["banner-title"]}>{item?.name}</h1>
                    )}
                    <p className={styles["banner-sub-title"]}>{item?.briefIntroduction}</p>
                  </div>
                </div>
              )
            })}
        </Carousel>
    </div>
    )}
    </>

  );
};

export default Banner;
